import { hash } from '@dogfy/lib/utils'

const PRIVATE_PARAMS = ['email', 'phone']

const consentListeners = []

const gtmConfig = { isEnabled: false }
let appEnvironment

function canBeEnabled (route) {
  return gtmConfig.enable && (route.query.gtm === 'enabled' || appEnvironment === 'production')
}

function enable () {
  const { isEnabled, id: gtmId, layer } = gtmConfig
  if (isEnabled) return

  gtmScript(window, document, 'script', layer, gtmId)

  gtmConfig.isEnabled = true

  // Set noscript just after body tag opening.
  const noscript = document.createElement('noscript')

  const iframe = document.createElement('iframe')
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
  iframe.height = '0'
  iframe.width = '0'
  iframe.style = {
    display: 'none',
    visibility: 'hidden',
  }

  noscript.appendChild(iframe)

  const s = document.body.firstChild
  s.parentNode.insertBefore(noscript, s)
}

async function push (object) {
  const { userData = {} } = object

  const { isEnabled, layer } = gtmConfig
  if (!isEnabled) return

  if (!window[layer]) {
    window[layer] = []
  }

  for (const key in userData) {
    if ([undefined, null].includes(userData[key])) {
      delete userData[key]
      continue
    }

    if (!PRIVATE_PARAMS.includes(key)) continue

    const hashedData = await hash(userData[key])
    if (hashedData) {
      userData[key] = hashedData
    } else {
      delete userData[key]
    }
  }

  window[layer].push(object)
}

function gtmScript (w, d, s, l, i) {
  const { layer } = gtmConfig
  w[l] = w[l] || []

  // Fix the Rogue referral problem
  const { protocol, hostname, pathname, search } = d.location
  w[l].push({
    originalLocation: protocol + '//' + hostname + pathname + search,
  })

  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  })
  const f = d.getElementsByTagName(s)[0]
  const j = d.createElement(s)
  const dl = l !== layer ? '&l=' + l : ''
  j.async = true
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
  f.parentNode.insertBefore(j, f)
}

function consentChange (consent) {
  consentListeners.forEach((callback) => callback(consent))
  push({ event: 'cookiesConsent', ...consent })
}

function installPlugin (app, options = {}, router, route, currentEnv) {
  if (!options.id) throw new Error('GTM ID is required')

  appEnvironment = currentEnv

  Object.assign(gtmConfig, options)

  if (canBeEnabled(route)) enable()

  window.consentListener = (callback) => {
    consentListeners.push(callback)
  }

  if (options.pageTracking) {
    router.afterEach((to, from) => {
      if (!gtmConfig.isEnabled) return
      // Do not track page reloads
      if (to.path === from.path) return

      push({
        routeName: to.name,
        pageType: 'PageView',
        pageUrl: to.fullPath,
        pageTitle: (typeof document !== 'undefined' && document.title) || '',
        event: 'vueRoute',
      })
    })
  }
  app.provide('gtm', this)
}

export default {
  install: installPlugin,
  canBeEnabled,
  enable,
  push,
  consentChange,
}
